import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';


// Slider
// ----------------------------
(function ($) {
    const $body = $('body'),
        inBackend = $body.hasClass('neos-backend');

    // Partner slider
    $(function () {
        const containerSelector = '.swiper--partner-slider',
        slideSelector = '.swiper-slide',
        swiper = new Swiper(containerSelector, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },
                600: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 40
                }
            },
            centerInsufficientSlides: true,
            spaceBetween: 40,
            navigation: {
                nextEl: ".swiper-button-next--partner",
                prevEl: ".swiper-button-prev--partner",
            },
            pagination: {
                el: ".swiper-pagination",
            },
        });
        if (inBackend) {
            swiper.destroy(true)
        }
    });

    $(function () {
        const containerSelector = '.swiper--review-slider',
            slideSelector = '.swiper-slide',
            swiper = new Swiper(containerSelector, {
                modules: [Navigation, Pagination],
                slidesPerView: 1,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 20
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1050: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                },
                centerInsufficientSlides: true,
                spaceBetween: 40,
                navigation: {
                    nextEl: ".swiper-button-next--review",
                    prevEl: ".swiper-button-prev--review",
                },
                pagination: {
                    el: ".swiper-pagination",
                },
            });
        if (inBackend) {
            swiper.destroy(true)}
    });
})(jQuery);
